<template>
  <div
    @click="showRaw = !showRaw"
    class="relative inline-block w-10 mr-2 mb-2 align-middle select-none transition duration-200 ease-in">
    <input
      :checked="showRaw"
      type="checkbox"
      name="toggle"
      class="toggle-checkbox absolute outline-none block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" />
    <label
      for="toggle"
      class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer">
    </label>
  </div>
  <label for="toggle" class="text-xs text-gray-700">Raw HTML</label>
  <br/>
  <textarea
    class="w-full"
    v-model="quillBody"
    v-if="showRaw"
    v-on:input="emitBody($event.target.value);"
  />
  <div id="quillbox" v-if="!showRaw">
    <QuillEditor
      :modules="modules"
      :toolbar="toolbar"
      ref="editor"
      v-model:content="quillBody"
      contentType="html"
      placeholder="Define your template"
      theme="snow"
      bounds="#quill-template"
      @update:content="emitBody(quillBody);"
    />
  </div>
  <div id="html-block" style="z-index:10"></div>
  <input class="hidden" type="file" id="getFile" @change="uploadFunction($event)" />
</template>

<style>
  /* CHECKBOX TOGGLE SWITCH */
  /* @apply rules for documentation, these do not work as inline style */
  .toggle-checkbox:checked {
    @apply: right-0 border-green-400;
    right: 0;
    border-color: #68d391;
  }
  .toggle-checkbox:checked + .toggle-label {
    @apply: bg-green-400;
    background-color: #68d391;
  }
</style>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import BlotFormatter from 'quill-blot-formatter'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import htmlEditButton from "quill-html-edit-button";

import gravyAxios from "@/plugins/axios";

export default {
  created() {
    this.calcRaw(this.$props.quillBody)
  },
  components: {
    QuillEditor,
  },
  props: ['quillBody'],
  emits: ['update:quillBody'],
  data() {
    return {
      showRaw: false,
      toolbar: {
        container: [
          [{'header':[1,2,3,false]},{'color':[]}],
          ['bold','italic','underline','link','image'],
          [{'list':'ordered'},{'list':'bullet'}],
          ['clean']
        ],
        handlers: {
          image: function() { document.getElementById('getFile').click(); }
        }
      },
      modules: [
        { name: 'blotFormatter', module: BlotFormatter, options: {} },
        { name: 'htmlEditButton', module: htmlEditButton, options: { prependSelector: "#html-block"} },
      ],
    }
  },
  methods: {
    emitBody(body) {
      this.$emit('update:quillBody', body)
    },
    async uploadFunction(e) {
      if (e.target.files.length != 1) {
        throw "Only a single file may be added at a time"
      }
      var form = new FormData()
      form.append("image", e.target.files[0])

      document.getElementById('getFile').value = null
      let errorMessage = await gravyAxios.post(`/image/store`, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(function (response) {
          if (response.data) {
            const range = this.quill.getSelection()
            this.quill.insertEmbed(range.index, 'image', encodeURI(gravyAxios.defaults.baseURL + response.data.url))
          } else {
            return "Invalid response format"
          }
        }.bind({quill: this.$refs.editor.getQuill()}))
        .catch(function (error) {
          if (error.response?.data?.errors) {
            return error.response.data.errors
          } else {
            return error.message
          }
        });
      if (errorMessage) {
        throw errorMessage
      }
    },
    isQuillBody(body) {
      return body.startsWith("<p>") || !body.startsWith("<")
    },
    calcRaw(body) {
      if (!this.isQuillBody(body)) {
        this.showRaw = true
      } else {
        this.showRaw = false
      }
    }
  },
}
</script>
